export default {
  SET_IMAGES (state, images) {
    state.images = images
  },

  SET_CURRENT_GALLERY (state, gallery) {
    state.current_gallery = gallery
  }
}
